<div *ngIf="notApplicable" style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>
<div #parentDiv class="parentDiv" id="parentDiv" *ngIf="!isLoading && !notApplicable" [hidden]="chartproperties.chartStyle!='style1'"
    [style.background]="chartproperties.darkTheme?'black':'white'" [ngStyle]="{'align-items':isOutput?'center':'','display':isOutput?'flex':'','justify-content':isOutput?'center':'','height': popUp ? '28em' : (isOutput ? (height === '22em' ? '20em' : 'calc(100% - 2rem)') : '100%')}">
    <!-- <h3 id="title" [style.color]="chartproperties.darkTheme?'white':'black'">Chart Title</h3> -->
    <!-- <div class="chart-container">

        <div class="stencil1">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[0]}}</div>
            <div class="background-fill-stencil1">
                <div class="childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    [style]="!isLoading?'background-color: grey;':'background-color: transparent;'"></div>
                <div class="childDiv1-stencil1" [style.background]="'#3E73EA'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[0]*100/maxdata:data[0]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[0]:100-data[0])"
                        [style]="!isLoading?'background-color: grey;':'background-color: transparent;'"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'../../../../../../../../assets/ImagesSnapshot/FillChart/stencil_light_solid1.png':'assets/Images/FillChart/stencil_dark6.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[0]}}</div>
        </div>


        <div class="stencil2">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[1]}}</div>
            <div class="background-fill-stencil2">
                <div class="childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="childDiv1-stencil2" [style.background]="'#EB5B61'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[1]*100/maxdata:data[1]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[1]:100-data[1])"
                        style="background-color: grey;"></div>
                </div>

            </div>
            <img [src]="!chartproperties.darkTheme?'../../../../../../../../assets/ImagesSnapshot/FillChart/stencil_light_solid1.png':'assets/Images/FillChart/stencil_dark3.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[1]}}</div>
        </div>


        <div class="stencil3">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[2]}}</div>
            <div class="background-fill-stencil3">
                <div class="childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="childDiv1-stencil3" [style.background]="'#F3AD50'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[2]*100/maxdata:data[2]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[2]:100-data[2])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'../../../../../../../../assets/ImagesSnapshot/FillChart/stencil_light_solid1.png':'assets/Images/FillChart/stencil_dark2.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[2]}}</div>
        </div>
    </div> -->
    <div class="chart-container2" [ngStyle]="{'margin-top':isOutput?'0%':'15%'}">

        <div  [ngClass]="isOutput ? (popUp? 'stencil-popup':(widgetCount == 6 ?'stencil-6widget':(height == '22em'? 'stencil-single':'stencil-4widget'))) : 'stencil'" *ngFor="let data1 of (widgetCount == 7 || widgetCount == 3 ? paginatedData : data); let i = index">
            <!-- <div class="categoryname" id="categoryname" style="top:0em;justify-content: center;text-align: center;cursor: pointer;-webkit-line-clamp: initial; overflow: visible;" title="{{name[i]}}">
               <span style="text-overflow: unset; -webkit-line-clamp: initial; overflow: visible; display: block;position: relative;z-index: 9;transform: translateY(-8px);-webkit-transform: translateY(-8px);-moz-transform: translateY(-8px);-o-transform: translateY(-8px);font-size: 10px;height: 16px;">{{name[i]}}</span>
            </div> -->
            <div #categoryDiv class="categoryname" id="categoryname" [class.single-line]="isSingleLine[i]" style="top:0em;justify-content: center;text-align: center;cursor: pointer;font-size: 0.8em;" title="{{name[i]}}">
                <span style="font-size:0.7em;">{{name[i]}}</span>
            </div>
            <div [ngClass]="isOutput ?(popUp? 'background-fill-stencil-popup': (widgetCount == 6 ?'background-fill-stencil-6widget':(height == '22em'? 'background-fill-stencil-single':'background-fill-stencil-4widget'))) : 'background-fill-stencil'">
                <div class="childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    [style]="!isLoading?'background-color: grey;':'background-color: transparent;'"></div>
                <div class="childDiv1-stencil" [style.background]="customcolors[getFillIndex(i)]"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data1*100/maxdata:data1):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                    [style.height.%]="(chartproperties.filltomax ? maxdata - data1 : scaledata(data2[getFillIndex(i)]))"
                        [style]="!isLoading?'background-color: ' + (chartproperties.backgroundColor || '#CCCCCC') + ';':'background-color: transparent;'"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'../../../../../../../../assets/ImagesSnapshot/FillChart/stencil_light_solid1.png':'../../../../../../../../assets/ImagesSnapshot/FillChart/stencil_light_solid1.png'"
                alt="unique-chart" class="unique-chart stencil-image">

            <div class="datalabel" id="datalabel"
                [ngStyle]="{'color': (chartproperties.dataLabelColor=='default' ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor), 'font-size': '0.7em', 'top': '0em', 'justify-content': 'center', 'text-align': 'center'}">
                <span [innerHTML]="getValue(data[i],i)" [ngStyle]="{'color': (chartproperties.dataLabelColor=='default' ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor), 'font-size': chartproperties?.dataLabelSize}"></span>
            </div>
                <div class="Changevs" id="Changevs" *ngIf="isOutput && chartproperties.datalabelStyle!='datalabel'" [ngStyle]="{'font-size': chartproperties?.dataLabelSize,'color':getSigColor(i)}"
                style="top:0em;justify-content: center;text-align: center;font-size:0.5em;"><span [innerHTML]="getChangeVs(i)"  [ngStyle]="{'font-size': chartproperties?.dataLabelSize,'color':getSigColor(i)}"></span></div>
        </div>
    </div>
    <div *ngIf="(widgetCount == 7 || widgetCount == 3) && totalPages > 1"
        style="position:absolute;bottom:0.3rem;right:0.3rem;display:flex;align-items:center;gap:0.3rem;">
        <span (click)="fillPaginate('left'); $event.stopPropagation()"
            [style.opacity]="fillChartPage==0?'0.3':'1'"
            style="cursor:pointer;font-size:1rem;">&#8249;</span>
        <span style="font-size:0.6rem;">{{fillChartPage+1}}/{{totalPages}}</span>
        <span (click)="fillPaginate('right'); $event.stopPropagation()"
            [style.opacity]="fillChartPage==totalPages-1?'0.3':'1'"
            style="cursor:pointer;font-size:1rem;">&#8250;</span>
    </div>
</div>
<!-- 
<div #parentDiv2 class="parentDiv2" id="parentDiv2" *ngIf="!notApplicable" [hidden]="chartproperties.chartStyle!='style2'">
    <h3 id="title2" [style.color]="chartproperties.darkTheme?'white':'black'">Chart Title</h3>
    <div class="chart-container">

        <div class="stencil1">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[0]}}</div>
            <div class="style2-background-fill-stencil1" id="style2backgroundfillstencil1">
                <div class="style2-childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="style2-childDiv1-stencil1" id="style2-childDiv1-stencil1 " [style.background]="'blue'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[0]*100/maxdata:data[0]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[0]:100-data[0])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'assets/Images/FillChart/stencil_light8.png':'assets/Images/FillChart/stencil_dark8.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[0]}}</div>
        </div>


        <div class="stencil2">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[1]}}</div>
            <div class="style2-background-fill-stencil2" id="style2backgroundfillstencil2">
                <div class="style2-childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="style2-childDiv1-stencil2" id="style2-childDiv1-stencil2 " [style.background]="'red'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[1]*100/maxdata:data[1]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[1]:100-data[1])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'assets/Images/FillChart/stencil_light8.png':'assets/Images/FillChart/stencil_dark8.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[1]}}</div>
        </div>


        <div class="stencil3">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                {{name[2]}}</div>
            <div class="style2-background-fill-stencil3" id="style2backgroundfillstencil3">
                <div class="style2-childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="style2-childDiv1-stencil3" id="style2-childDiv1-stencil3 " [style.background]="'yellow'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[2]*100/maxdata:data[1]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[2]:100-data[2])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'assets/Images/FillChart/stencil_light8.png':'assets/Images/FillChart/stencil_dark8.png'"
                alt="unique-chart" class="unique-chart stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[2]}}</div>
        </div> 
    </div>
</div>

<div #parentDiv3 class="parentDiv3" id="parentDiv3" *ngIf="!notApplicable" [hidden]="chartproperties.chartStyle!='style3'"
    [style.background]="chartproperties.darkTheme?'black':'white'">
    <h3 id="title" [style.color]="chartproperties.darkTheme?'white':'black'">Chart Title</h3> 
    <div class="chart-container">

        <div class="stencil1">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                Female</div>
            <div class="style3-background-fill-stencil1" id="style3backgroundfillstencil1">
                <div class="style3-childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="style3-childDiv1-stencil1" id="style3-childDiv1-stencil1 " [style.background]="'pink'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[0]*100/maxdata:data[0]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[0]:100-data[0])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'assets/Images/FillChart/stencil_light4.png':'assets/Images/FillChart/stencil_dark4.png'"
                alt="unique-chart" class="unique-chart style3-stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[0]}}</div>
        </div>


        <div class="stencil2">
            <div class="categoryname" id="categoryname" style="top:-1em;justify-content: center;text-align: center;">
                Male</div>
            <div class="style3-background-fill-stencil2" id="style3backgroundfillstencil2">
                <div class="style3-childDivgreyfill" id="childDivgreyfill"
                    [hidden]="!(chartproperties.filldirection!='vertical')" [style.height.%]="100"
                    style="background-color: grey;"></div>
                <div class="style3-childDiv1-stencil2" id="style3-childDiv1-stencil2 " [style.background]="'blue'"
                    [style.width.%]="chartproperties.filldirection!='vertical'?(chartproperties.filltomax?data[1]*100/maxdata:data[1]):100">
                    <div *ngIf="chartproperties.filldirection=='vertical'"
                        [style.height.%]="(chartproperties.filltomax?maxdata-data[1]:100-data[1])"
                        style="background-color: grey;"></div>
                </div>
            </div>
            <img [src]="!chartproperties.darkTheme?'assets/Images/FillChart/stencil_light5.png':'assets/Images/FillChart/stencil_dark5.png'"
                alt="unique-chart" class="unique-chart style3-stencil-image">
            <div class="datalabel" id="datalabel" [style.font-size]="chartproperties.dataLabelSize"
                [style.color]="(chartproperties.dataLabelColor=='default'?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor)"
                style="top:1em;justify-content: center;text-align: center;">{{data[1]}}</div>
        </div> 

    </div>
</div> -->